import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EunoiaPage from './pages/EunoiaPage';
import PrivacyPolicy from './pages/PrivacyPolicy';

const EunoiaRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<EunoiaPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default EunoiaRoutes;
